import { tv } from 'tailwind-variants';

const groupContainerStyle = tv({
  base: 'gap-2',
  variants: {
    orientation: {
      horizontal: 'flex-row gap-x-5',
      vertical: 'flex-col gap-y-3',
    },
  },
});

const inputStyle = tv({
  base: 'transition-all duration-200 bg-white border-2 rounded appearance-none cursor-pointer peer border-secondary-three focus:outline-none focus-visible:outline-none',
  variants: {
    design: {
      primary:
        'hover:border-primary-one checked:border-primary-one checked:bg-primary-one',
      admin:
        'hover:border-secondary-two checked:border-secondary-two checked:bg-secondary-two',
      textDecorator: 'hidden',
    },
    inputSize: {
      sm: 'w-4 h-4',
      md: 'w-5 h-5',
      lg: 'w-6 h-6',
    },
    errored: {
      true: 'border-primary-two',
    },
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:border-slate-100 disabled:bg-slate-50',
    },
  },
  defaultVariants: {
    design: 'primary',
  },
});

const labelStyle = tv({
  base: 'flex gap-x-2 cursor-pointer text-sm w-full relative transition-all',
  variants: {
    design: {
      primary: 'text-secondary-two',
      admin: 'text-secondary-one',
      textDecorator:
        'items-center justify-center border border-zinc-200 rounded-lg text-gray-600 w-9 h-9 has-[:checked]:bg-black has-[:checked]:text-white',
    },
    bold: {
      true: 'font-bold',
    },
    italic: {
      true: 'italic',
    },
    underline: {
      true: 'underline',
    },
    errored: {
      true: 'text-primary-two',
    },
    disabled: {
      true: 'peer-disabled:cursor-not-allowed peer-disabled:text-slate-400 read-only:cursor-not-allowed read-only:text-slate-400',
    },
  },
  defaultVariants: {
    design: 'primary',
  },
});

const iconStyle = tv({
  base: 'absolute left-0 transition-all duration-300 -rotate-90 opacity-0 pointer-events-none peer-checked:rotate-0 peer-checked:opacity-100 peer-disabled:cursor-not-allowed',
  variants: {
    design: {
      primary:
        'fill-white stroke-white peer-hover:fill-white peer-hover:stroke-white peer-focus:fill-white peer-focus:stroke-white',
      admin:
        'fill-white stroke-white peer-hover:fill-white peer-hover:stroke-white peer-focus:fill-white peer-focus:stroke-white',
      textDecorator: '',
    },
    size: {
      sm: 'w-4 h-4',
      md: 'w-5 h-5',
      lg: 'w-6 h-6',
    },
    disabled: {
      true: 'peer-disabled:cursor-not-allowed peer-read-only:cursor-not-allowed',
    },
  },
});

export const checkboxStyles = {
  groupContainer: groupContainerStyle,
  input: inputStyle,
  label: labelStyle,
  icon: iconStyle,
};
